import React, { ReactNode } from 'react'
import { StickyCurrencies, StickyCurrenciesContext } from './context'
import { useEthers, useLocalStorage } from '../../hooks'
import { ChainId, CURRENCIES, DEFAULT_PAIRS } from '../../constants'

interface Props {
  children: ReactNode
}

export function StickyCurrenciesProvider({ children }: Props) {
  const { chainId = ChainId.Mainnet } = useEthers()
  const [savedStickyCurrencySymbols, setStickyCurrencySymbols] = useLocalStorage('stickyCurrencySymbols')

  function getStickyCurrencies(): StickyCurrencies {
    const first =
      savedStickyCurrencySymbols &&
      CURRENCIES[chainId].find((currency) => currency.symbol === savedStickyCurrencySymbols.first)
    const second =
      savedStickyCurrencySymbols &&
      CURRENCIES[chainId].find((currency) => currency.symbol === savedStickyCurrencySymbols.second)
    if (first && second) {
      return { first, second }
    }
    return {
      first: DEFAULT_PAIRS[chainId].tokens[0],
      second: DEFAULT_PAIRS[chainId].tokens[1],
    }
  }

  const setStickyCurrencies = (stickyCurrencies: StickyCurrencies) => {
    const { first, second } = stickyCurrencies
    if (first.symbol === second.symbol) {
      throw new Error('Cannot set currencies to same symbol')
    }
    setStickyCurrencySymbols(() => ({
      first: first.symbol,
      second: second.symbol,
    }))
  }

  return (
    <StickyCurrenciesContext.Provider
      value={{ stickyCurrencies: getStickyCurrencies(), setStickyCurrencies }}
      children={children}
    />
  )
}
